import { useSyncExternalStore } from 'react'

import { getTokenSnapshot, subscribeToken } from '@/apis/tokenStore'

/**
 * React 컴포넌트가 토큰 유무를 구독해서 token 변경 시 자동 re-render.
 *
 * 카카오 redirect 처럼 외부에서 webview 로 새로 진입한 직후엔 useInitAuth 가
 * 브릿지 getAuthToken 응답을 받기 전 (=tokenStore 비어있는 상태) 이므로,
 * 인증 필요 API 를 호출하기 전에 이 hook 으로 토큰 준비 여부를 가드한다.
 */
export function useHasToken(): boolean {
  const token = useSyncExternalStore(subscribeToken, getTokenSnapshot)
  return token != null && token !== ''
}
